export const siteContent = {
  brand: {
    name: 'Isaías Jiménez',
    tagline: 'MUSICIAN | ARRANGER | DESIGNER | DEVELOPER | INVENTOR',
    shortBio: 'Multi-talented musician, inspiring leader, innovative entrepreneur, creative arranger, visionary inventor.',
    logo: 'https://customer-assets.emergentagent.com/job_melody-merchant-3/artifacts/8acig6fz_Screenshot%202026-02-08%20at%205.03.01%E2%80%AFAM.png',
    heroImage: 'https://static.wixstatic.com/media/a8e1f3e15ccb41b88df85a10bb90531a.jpg',
  },
  
  bio: {
    heroImage: 'https://static.wixstatic.com/media/4a2ebb_e8f9d0fe1ab846809a3f1806c9da2994~mv2.jpg',
    paragraphs: [
      'Meet Isaías Jiménez, a dynamic trumpet player and versatile musician based in Mexico City. Isaías Jiménez is a Los Angeles–born trumpet player, composer, and musical entrepreneur based in Mexico City, with over 30 years of professional experience spanning jazz, classical, pop, and musical theater. Known for his versatility, precision, and stylistic authority, Isaías has built an international career as a soloist, lead trumpet, recording artist, educator, and innovator for brass musicians.',
      'After studying at the Hamilton Academy of Music in Los Angeles and California State University, Long Beach—where he trained under legendary studio trumpeters Wayne Bergeron and Charlie Davis—Isaías relocated to Mexico City in 2004 to immerse himself in one of the world\'s most dynamic music scenes.',
      'A deeply rooted jazz artist, Isaías has performed with some of the genre\'s most respected figures, including Paquito D\'Rivera, Wynton Marsalis, Wayne Bergeron, Arturo Sandoval, Sherman Irby, and Eddie Gomez. He toured internationally as lead trumpet with the Glenn Miller Orchestra and has held principal roles with Mexico\'s top big bands, including the National Jazz Orchestra of Mexico and Big Band Jazz de México. In 2010, he founded the Latin American Jazz Orchestra, serving as lead trumpet and producer. That same year, he produced Mexico\'s first Duke Ellington Homage Concert, supported by the Jazz at Lincoln Center Orchestra, marking a milestone for jazz presentation in the region.',
      'Isaías has appeared as principal trumpet and featured soloist with major orchestras across Mexico, including the Mexico City Philharmonic, Toluca Philharmonic, and Morelia Philharmonic. He was featured at Mexico City\'s First International Trumpet Festival and has been a soloist on national classical radio. His classical journey culminated in the release of his debut solo album, Art in Trumpet (2018) — a collection of virtuosic works and original arrangements for trumpet and piano, showcasing his technical mastery and artistic voice.',
      'In popular music, Isaías has recorded and performed with leading Latin artists such as Juan Gabriel, Natalia Lafourcade, Kalimba, Raúl Di Blasio, Edith Márquez, and Ximena Sariñana. He served as first trumpet for Juan Gabriel\'s final major world tour, one of the largest productions in Latin American music history. He is also a veteran musical theater musician, having performed in over 18 professional productions in Mexico and the United States, including Chicago, Wicked, Mary Poppins, Jersey Boys, Billy Elliot, and The Sound of Music, often as lead trumpet.',
      'Alongside his performance career, he is active as a music educator, arranger, and designer of innovative brass accessories and music apps, including ToneRegistry, a global instrument registration platform for musicians. In addition to trumpet, he performs professionally on saxophone and French horn, bringing rare multi-instrumental depth to every project. Driven by curiosity, craftsmanship, and a lifelong devotion to music, Isaías Jiménez continues to expand the boundaries of performance, education, and innovation—always in service of musical excellence.'
    ],
    testimonials: [
      {
        quote: 'Way to play your ass off, Keep up the great and innovative playing',
        author: 'Allen Vizzutti'
      },
      {
        quote: 'Really a wonderful job on this and I like the selection of music. So nice to hear you playing so very well. Congratulations.',
        author: 'Charlie Davis'
      },
      {
        quote: 'I just Heard your record, wowwww, you can play all the difficult pieces, amazing!!!',
        author: 'Arturo Sandoval'
      }
    ],
    achievements: [
      'Mexico City Philharmonic',
      'Toluca Symphony Orchestra',
      'Morelia Symphony Orchestra',
      'Glenn Miller Orchestra',
      'Latin America Jazz Orchestra (Founder)',
      '20+ Musical Theater Productions'
    ],
    collaborations: [
      'Juan Gabriel',
      'Natalia Lafourcade',
      'Paquito D\'Rivera',
      'Wayne Bergeron',
      'Arturo Sandoval',
      'Eddie Gomez'
    ]
  },
  
  toneRegistry: {
    name: 'ToneRegistry',
    tagline: 'The world\'s first digital registry for musical instruments',
    description: 'Protect and track your gear. Register instruments, track investments, smarter practice tools, and a marketplace for buying/selling.',
    appStoreUrl: 'https://apps.apple.com/us/app/toneregistry/id6756538205',
    features: [
      'Register your instruments',
      'Track your investment',
      'Smarter practice tools',
      'Buy & sell marketplace'
    ],
    availability: {
      ios: true,
      android: false,
      androidNote: 'Coming soon to Android'
    }
  },
  
  noteTurner: {
    name: 'NoteTurner',
    tagline: 'Hands-free page turning for musicians',
    description: 'A game-changing page-turner for sax, clarinet, trumpet, and trombone players. Turn pages on ForScore or almost any PDF app with the press of a button.',
    price: 34.99,
    originalPrice: 39.99,
    features: [
      'Bluetooth enabled',
      'Works with ForScore & similar PDF apps',
      'iPad & Android compatible',
      'Screen lock/unlock feature',
      '40+ hour battery life',
      'Takes selfies'
    ],
    images: [
      'https://static.wixstatic.com/media/4a2ebb_895ee36e15ba4f70aee1a0473dc735c4~mv2.jpg',
      'https://static.wixstatic.com/media/4a2ebb_86ec922c8aaa4c3b827c3322d8c331c0~mv2.jpeg',
      'https://static.wixstatic.com/media/4a2ebb_1db02ea42d264adeacbe529611f8fef0~mv2.jpeg'
    ]
  },
  
  links: {
    lajo: 'https://lajo.com.mx/',
    wixStore: 'https://www.jimendez.com/shop',
    toneRegistry: 'https://apps.apple.com/us/app/toneregistry/id6756538205'
  },

  contact: {
    email: 'trumpet95@gmail.com',
    location: 'Mexico City',
    shipping: 'Worldwide Shipping Available'
  }
};
